import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { Button, ButtonArrange, Flex } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Illustration } from '@component/illustration/mod';
import { Title } from '@component/title.component';
import { TopBar } from '@component/top_bar.component';
import { useEffect } from 'react';
import styled from 'styled-components';
import { FlowSettingsError, useBooking } from '../../hooks/use_booking';

const elements = {
	container: styled(Flex)`
		text-align: center;
		max-width: 400px;
	`,
	illustration: styled(Illustration)`
		width: 200px;
		max-width: 100%;
		height: auto;
	`,
};

interface ErrorProps {
	error?: FlowSettingsError;
}

export function ScreenError(_: ErrorProps) {
	const viewBooking = useBooking();
	const analytics = useAnalyticContext();

	function handleRestart() {
		analytics.trackEvent('Clicked start over');
		viewBooking.goToReceptionHome();
	}

	useEffect(() => {
		analytics.service.trackPageView({
			customTitle: 'Booking: Error',
		});
	}, [analytics]);

	return (
		<>
			<TopBar.Content onAbort={null} />
			<Flex gap={tokens.spacing.x4} grow={1} align='center' justify='center'>
				<elements.container align='center' gap={tokens.spacing.x2_5} grow={1}>
					<elements.illustration type='error' />
					<Title
						title={withTranslation('View.Booking.ErrorInterrupted.Title')}
						titleSize='small'
						description={withTranslation('View.Booking.ErrorInterrupted.Body')}
					/>
				</elements.container>
				<Flex style={{ width: '100%' }}>
					<ButtonArrange justify='center'>
						<Button variant='primary' onClick={handleRestart}>
							{withTranslation('View.Booking.ErrorInterrupted.Button')}
						</Button>
					</ButtonArrange>
				</Flex>
			</Flex>
		</>
	);
}
